import { useMemo } from "react";
import type { ProtoRadarData } from "@catbento/shared";
import { readSnapshot } from "../data/snapshot.js";
import { getRadarData } from "../data/radar.js";

// Phase 02 seam: one player's radar values for a season (radarMetrics merged over
// stats). The per-template axis order + population scaling are NOT here — axis
// order is renderer logic (Phase 04), scaling is the shared population read. At
// the Part-2 cutover this hook fetches the player's per-90 stats (position-
// filtered) and adapts to the same ProtoRadarData shape. Returns null when the
// name isn't in the snapshot.
export function useRadarData(name: string, season?: string): ProtoRadarData | null {
  return useMemo(() => getRadarData(readSnapshot().players, name, season), [name, season]);
}
